// extracted by mini-css-extract-plugin
module.exports = {"compactWrapper":"ReceiverLocationSelector_compactWrapper__1Ucoh","receiverLocation":"ReceiverLocationSelector_receiverLocation__3JV6O"};